import React, { useCallback, useEffect, useState, useRef } from "react";
import { ReactComponent as ExamIcon } from "../../../images/examimage/examicon.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";
import QuestionHead from "../../../CustomComponent/QuestionHead";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import TableView from "../../../CustomComponent/TableView";
import ResultHead from "../../../CustomComponent/ResultHead";
import { ReactComponent as ResultIcon } from "../../../images/questionimage/resulticon.svg";
import ExamLogo from "../../../images/questionimage/examlogo.jpg";
import { useParams, useLocation } from "react-router-dom";
import { decryptData } from "../../../../crypto";
import axios from "axios";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { ReactComponent as LoginIcon } from "../../../images/DashboardLoginImage/Student login icon.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import SendIcon from "@material-ui/icons/Send";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { Button, Paper, Popover, Tooltip, withStyles } from "@material-ui/core";
import Loader from "../../../CustomComponent/Loader";
import socket from "../../../socket/socket";
import { debounce } from "lodash";
import { useNavigate } from "react-router-dom";

function ExamFeedbackDashboard() {
  const classes = useStyles();
  const { rowId } = useParams();
  const location = useLocation();
  const desiredPath = `/admin/examfeedbackdashboard/${rowId}`;
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);

  const [rowCount, setRowCount] = useState("");
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const [changeStatus, setChangeStatus] = useState([]);

  const [page, setPage] = useState(0);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage); // Pass newSelection directly
  };

  const [examDetails, setExamDetails] = useState({
    examName: "",
    courseName: "",
    batchName: "",
    subjectNames: "",
    examImage: "",
  });

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`,
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
            },
          }
        );

        const exam = response.data.exam;
        const subjectNames = exam.subjects
          .map((sub) => sub.subject_name)
          .join(", ");

        setExamDetails({
          examName: exam.exam_name,
          courseName: exam.course.map((c) => c?.course_name).join(", "),
          batchName: exam.batch.map((c) => c?.batch_name).join(", "),
          subjectNames: subjectNames,
          centers: exam.center,
          examImage: exam.image_url,
        });
      } catch (error) {
        console.error("Error fetching exam data: ", error);
      }
    };

    fetchExamData();
  }, [rowId, decryptedToken]);

  const formatDate = (dateString) => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  const [givingExamData, setGivingExamData] = useState([]);
  const [filteredGivingExamData, setFilteredGivingExamData] = useState([]);

  // useEffect(() => {
  //   setFilteredGivingExamData(givingExamData);
  // }, [givingExamData]);

  const debouncedSearch = useCallback(
    debounce((value) => {
      setSearchQuery(value.trim());
    }, 500),
    []
  );

  const onSearchGivingExam = (query) => {
    debouncedSearch(query); // ✅ Call the debounce wrapper, not setSearchQuery directly
  };
  // const onSearchGivingExam = (query) => {
  //   // const filteredData = givingExamData.filter((learner) =>
  //   //   learner.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //   // learner.roll_number.toLowerCase().includes(searchQuery.toLowerCase())

  //   // );
  //   // setFilteredGivingExamData(searchQuery);
  //   //  setSearchQuery(searchQuery);
  //     setSearchQuery(query);

  // };
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const [centerFilterData, setCenterFilterData] = useState("");
  const [centerFilterData2, setCenterFilterData2] = useState("");
  const [filterData, setFilterData] = useState("All");

  const fetchDashboardExamData = async (
    rowId,
    pageNumber,
    size,
    branch,
    center,
    branchStatus,
    search
  ) => {
    if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;
    const status = branchStatus === "All" ? "" : branchStatus;

    try {
      const response = await axios.get(
        // `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/giving/${rowId}`,
        `${
          process.env.REACT_APP_API_BASE_URL
        }/v1/b2b/exam/giving/pagination/${rowId}?page=${
          pageNumber + 1
        }&limit=${size}&branchSearch=${branch}&centerSearch=${center}&statusSearch=${status}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      setRowCount(response?.data?.total_count);
      let learners = response.data.learners;
      const startIndex = pageNumber * size;

      const statusData = learners.map((learner) => ({
        userId: Number(learner.user_id),
        examId: Number(learner.exam_id),
        status:
          learner.status.charAt(0).toUpperCase() + learner.status.slice(1),
      }));

      setChangeStatus(statusData);

      let formattedData = learners.map((learner, index) => ({
        id: learner.user_id,
        srno: startIndex + index + 1,
        roll_number: learner.roll_number,
        name: learner.learner_name,
        phone: learner.phone,
        email: learner.email,
        center_code: `${learner.center_code} - ${learner.center_name}`,
        batch_code: learner?.batch?.batch_name || "N/A",
        center_code2:
          learner.center_code2 && learner.center_name2
            ? `${learner.center_code2} - ${learner.center_name2}`
            : "N/A",
        status: capitalizeFirstLetter(learner.status),
        registrationData: formatDate(learner.registration_date),
        remaining_time: `${
          learner.remaining_time === "00:00:00"
            ? "Time Lapse"
            : learner.remaining_time
        }`,
      }));

      // Apply dropdown Center filter
      // if (centerFilterData.toLowerCase() == "All Center") {
      //   formattedData = formattedData.filter(
      //     (learner) =>
      //       learner.center_code.toLowerCase() === centerFilterData.toLowerCase()
      //   );
      // }

      // // Apply dropdown filter
      // if (filterData.toLowerCase() == "All") {
      //   formattedData = formattedData.filter(
      //     (learner) => learner.status.toLowerCase() === filterData.toLowerCase()
      //   );
      // }

      // Apply search filter only if there is a search query
      // if (searchQuery) {
      //   formattedData = formattedData.filter((learner) =>
      //     learner.name.toLowerCase().includes(searchQuery.toLowerCase())
      //   );
      // }
      console.log("formattedData", formattedData);
      setFilteredGivingExamData(formattedData);
    } catch (error) {
      console.error("Error fetching exam data: ", error);
    }
  };

  // useEffect(() => {
  //   console.log("searchquery",searchQuery,rowId, onPage, pageSize ,centerFilterData, filterData)
  //   if (location.pathname === desiredPath || onPage !== undefined && pageSize !== undefined && centerFilterData !== undefined && filterData !== undefined && searchQuery !== null) {
  //     fetchDashboardExamData(rowId, onPage, pageSize ,centerFilterData, filterData, searchQuery);
  //     const intervalId = setInterval(() => {
  //       fetchDashboardExamData(rowId, onPage, pageSize ,centerFilterData, filterData, searchQuery);
  //     }, 60000);

  //     return () => clearInterval(intervalId);
  //   }
  // }, [rowId, onPage, pageSize ,centerFilterData, filterData, searchQuery]);
  const hasFetchedData = useRef(false);

  useEffect(() => {
    if (!rowId || !pageSize) return;

    const shouldFetch =
      location.pathname === desiredPath &&
      typeof onPage === "number" &&
      typeof pageSize === "number" &&
      centerFilterData !== undefined &&
      filterData !== undefined;

    if (!shouldFetch) return;

    // if (centerFilterData || filterData || searchQuery) {
    //   hasFetchedData.current = false;
    // }

    // if (hasFetchedData.current) return;
    // hasFetchedData.current = true;

    fetchDashboardExamData(
      rowId,
      onPage,
      pageSize,
      centerFilterData,
      centerFilterData2,
      filterData,
      searchQuery
    );

    // const intervalId = setInterval(() => {
    //   fetchDashboardExamData(
    //     rowId,
    //     onPage,
    //     pageSize,
    //     centerFilterData,
    //     filterData,
    //     searchQuery
    //   );
    // }, 60000);

    // return () => clearInterval(intervalId);
  }, [
    rowId,
    onPage,
    pageSize,
    centerFilterData,
    filterData,
    searchQuery,
    centerFilterData2,
  ]);

  // useEffect(() => {
  //   hasFetchedData.current = false;
  // }, [pageSize]);

  useEffect(() => {
    socket.connect();

    const handleStatusChange = (data) => {
      // Add validation for incoming data
      if (!data || !data.userId || !data.examId) {
        console.error("Invalid status change data:", data);
        return;
      }
      setChangeStatus((prev) => {
        const existingIndex = prev.findIndex(
          (item) =>
            Number(item.userId) === Number(data.userId) &&
            Number(item.examId) === Number(data.examId)
        );

        if (existingIndex >= 0) {
          // Update existing entry while preserving other properties
          return prev.map((item, index) =>
            index === existingIndex ? { ...item, status: data.status } : item
          );
        }

        // Add new entry
        return [
          ...prev,
          {
            examId: data.examId,
            userId: data.userId,
            status: data.status,
          },
        ];
      });
    };

    socket.on("changeStatus", handleStatusChange);

    return () => {
      socket.off("changeStatus", handleStatusChange);
      socket.disconnect();
    };
  }, []);

  // useEffect(() => {
  //   const applyFilter = () => {
  //     let filteredData = [...givingExamData];

  //     if (centerFilterData.toLowerCase() !== "all") {
  //       filteredData = filteredData.filter(
  //         (learner) =>
  //           learner.center_code.toLowerCase() === centerFilterData.toLowerCase()
  //       );
  //     }

  //     if (filterData.toLowerCase() !== "all") {
  //       filteredData = filteredData.filter(
  //         (learner) => learner.status.toLowerCase() === filterData.toLowerCase()
  //       );
  //     }

  //     setFilteredGivingExamData(filteredData);
  //   };

  //   applyFilter();
  // }, [givingExamData, filterData]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState();
  const [centerDeatil2, setCenterDeatil2] = useState([]);

  useEffect(() => {
    const selected = examDetails?.centers?.filter(
      (data) => data.center_name === centerFilterData && data
    );

    if (selected?.length > 0) {
      fetchCenter2(selected[0].id);
    }
  }, [centerFilterData]);

  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const Heading = [
    {
      id: 1,
      logo: examDetails.examImage,
      path: "/admin/feedback",
      headings: [
        {
          id: 11,
          label: "Name",
          content: examDetails.examName,
        },
        // {
        //   id: 12,
        //   label: "Subject",
        //   content: examDetails.subjectNames,
        // },
        {
          id: 13,
          label: "Course",
          content: examDetails.courseName,
        },
        {
          id: 14,
          label: "Batch",
          content: examDetails.batchName,
        },
      ],
    },
  ];

  const fetchCenter2 = async (id) => {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/parikshado/student/exam/auth/center/${id}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      if (response.data.success) {
        setCenterDeatil2(response.data.center);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const handleReloginSingle = async (selectedLearnerId) => {
    handleClose();
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/live/logout/one`;
    const requestBody = {
      exam: {
        exam_id: rowId,
        learner_id: selectedLearnerId,
      },
    };
    try {
      const response = await axios.put(apiUrl, requestBody, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });
      console.log("API Response:", response.data);
      // Display success message using toast
      toast.success(response.data.message || "Success!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      socket.emit("relogin", { examId: rowId, userId: selectedLearnerId });
      setChangeStatus((prev) => {
        const existingIndex = prev.findIndex(
          (item) =>
            Number(item.userId) === Number(selectedLearnerId) &&
            Number(item.examId) === Number(rowId)
        );

        if (existingIndex >= 0) {
          const updated = [...prev];
          updated[existingIndex] = {
            ...updated[existingIndex], // Keep existing examId, userId, etc.
            status: "Incomplete", // Only update status
          };
          return updated;
        }

        return prev; // Return unchanged if userId not found
      });
    } catch (error) {
      console.error("Error in PUT request:", error);
      toast.error(error.response?.data?.message || "An error occurred!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleSingleSubmit = async (selectedLearnerId) => {
    handleClose();
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/live/submit/one`;
    const requestBody = {
      exam: {
        exam_id: rowId,
        learner_id: selectedLearnerId,
      },
    };
    try {
      const response = await axios.put(apiUrl, requestBody, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });
      console.log("API Response:", response.data);
      // Display success message using toast
      toast.success(response.data.message || "Success!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      socket.emit("submit_exam", { examId: rowId, userId: selectedLearnerId });
      setChangeStatus((prev) => {
        const existingIndex = prev.findIndex(
          (item) =>
            Number(item.userId) === Number(selectedLearnerId) &&
            Number(item.examId) === Number(rowId)
        );

        if (existingIndex >= 0) {
          const updated = [...prev];
          updated[existingIndex] = {
            ...updated[existingIndex], // Keep existing examId, userId, etc.
            status: "Submitted", // Only update status
          };
          return updated;
        }

        return prev; // Return unchanged if userId not found
      });
    } catch (error) {
      console.error("Error in PUT request:", error);
      toast.error(error.response?.data?.message || "An error occurred!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleButtonClickQuestion = (type, userId, score) => {
    const data = {
      exam_name: examDetails?.examName,
      rowId,
      ...score,
    };
    navigate(`/admin/${type}/${userId}`, { state: data });
  };
  const givingcolumns = [
    {
      field: "srno",
      headerName: "Sr.No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 70,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "roll_number",
      headerName: "Roll Number",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "name",
      headerName: "Student Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "phone",
    //   headerName: "Phone",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 200,
    //   flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    {
      field: "batch_code",
      headerName: "Batch",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "center_code",
      headerName: "Branch Code",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "center_code2",
      headerName: "Center Code",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "registrationData",
    //   headerName: "Registration Date",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 180,
    //   flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    {
      field: "remaining_time",
      headerName: "Time Left",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "logs",
      headerName: "Logs",
      headerClassName: "super-app-theme--header",
      headerAlign: "center", // Align the column header to center
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => (
        <div
          className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter}`}
          style={{ height: "100%" }}
        >
          <Button
            className={`${classes.bluebtn} ${classes.ml1}`}
            // onClick={() => {
            //   handleViewApplicant(
            //     "viewtotalapplication",
            //     cellValues.row.id,
            //     cellValues.row.registration_code,
            //     cellValues.row.exam_name,
            //     cellValues.row.course_name
            //   );
            // }}
            onClick={() => {
              handleButtonClickQuestion(
                "activitylogs",
                cellValues.row.id,
                cellValues.row
              );
            }}
          >
            View
          </Button>
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Exam Status",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 170,
      autoPageSize: false,
      renderCell: (cellValues) => {
        const statusChange = changeStatus.find(
          (user) =>
            Number(user.userId) === Number(cellValues.row.id) &&
            Number(user.examId) === Number(rowId)
        );

        const currentStatus = statusChange?.status;

        return (
          <div
            className={`
${
  currentStatus === "Submitted"
    ? classes.statusSubmitted
    : currentStatus === "Giving"
    ? classes.statusGiving
    : currentStatus === "On instructions"
    ? classes.statusOnInstructions
    : currentStatus === "Incomplete"
    ? classes.statusIncomplete
    : classes.statusNotGiving
}
            ${classes.dflex} ${classes.alignitemscenter} ${
              classes.justifycenter
            } ${classes.mr0_5}  ${classes.ml0_5}
          `}
          >
            {(currentStatus === "Giving" ||
              currentStatus === "On instructions") && (
              <IconButton
                className={`${classes.w15} ${classes.bgwhite} ${classes.boxshadow4} ${classes.arrowicon}`}
                aria-describedby={id}
                onClick={(event) => {
                  handleClick(event, cellValues.row.id);
                }}
              >
                <ArrowLeftIcon fontSize="small" />
              </IconButton>
            )}
            <Typography
              className={`${classes.dflex} ${classes.alignitemscenter}`}
              variant="h6"
            >
              {(() => {
                const statusChange = changeStatus.find(
                  (user) =>
                    Number(user.userId) === Number(cellValues.row.id) &&
                    Number(user.examId) === Number(rowId)
                );

                const currentStatus = statusChange?.status;

                switch (currentStatus) {
                  case "Giving":
                    return <div>Started</div>;
                  case "On instructions":
                    return <div>On Instructions</div>;
                  case "Submitted":
                    return <div>Submitted</div>;
                  case "Incomplete":
                    return <div>Incomplete</div>;
                  case "Not giving":
                    return <div>Not Started</div>;
                  default:
                  // return <div>Unknown Status</div>; // or null if you prefer
                }
              })()}
            </Typography>
            <Popover
              id={id}
              open={popoveropen && selectedRowId === cellValues.row.id}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
            >
              <Paper>
                <IconButton
                  onClick={() => handleReloginSingle(cellValues.row.id)}
                >
                  <LightTooltip title="Re-Login">
                    <LoginIcon />
                  </LightTooltip>
                </IconButton>

                <IconButton
                  onClick={() => handleSingleSubmit(cellValues.row.id)}
                >
                  <LightTooltip title="Submit">
                    <SendIcon />
                  </LightTooltip>
                </IconButton>
              </Paper>
            </Popover>
          </div>
        );
      },
    },
  ];

  const GivingExam = [
    {
      id: 1,
      pageicon: <ResultIcon />,
      mainheading: "Live Feedback Dashboard",
      searchlabel: "Search Learner Name",
      placeholder: "Search By Class",
      style: "viewtable",
      relogin: "true",
      submit: "true",
      centerfilter: "true",
      filter: "true",
      height: "h61vh",
      report1: "Export File",
      refresh: "Refresh",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "server",
    },
  ];

  const [loaderOpen, setLoaderOpen] = useState(false);
  return (
    <>
      <ToastContainer />
      <div>
        <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
          <QuestionHead Heading={Heading} />
          <Loader loaderOpen={loaderOpen} />
          <ResultHead
            fetchDashboardExamData={fetchDashboardExamData}
            Heading={GivingExam}
            onSearch={onSearchGivingExam}
            centerFilterData={centerFilterData}
            setCenterFilterData={setCenterFilterData}
            centerFilterData2={centerFilterData2}
            setCenterFilterData2={setCenterFilterData2}
            filterData={filterData}
            setFilterData={setFilterData}
            rowId={rowId}
            decryptedToken={decryptedToken}
            dashboard={true}
            centerDeatil={examDetails.centers}
            centerDeatil2={centerDeatil2}
            setLoaderOpen={setLoaderOpen}
            onPage={onPage}
            pageSize={pageSize}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            setChangeStatus={setChangeStatus}
          />

          <TableView
            columns={givingcolumns}
            rows={filteredGivingExamData.map((row) => ({
              ...row,
              className: classes.tableRow,
            }))}
            Heading={GivingExam}
          />
        </div>
      </div>
    </>
  );
}
export default ExamFeedbackDashboard;
